import { useEffect, useState } from "react";
import { Typography, Row, Col, Input, Select, Alert, notification } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { setAllCompanyNames } from "../../redux/actions/mainAction";
import { setTriggerAnyEvent } from "../../redux/actions/globalAction";

const AddDepartment = () => {
  const { GlobalResponse } = useSelector((state) => state);
  const { MainResponse } = useSelector((state) => state);

  const [departmentName, setDepartmentName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [employeeCount, setEmployeeCount] = useState(0);
  const [showAlert, setShowAlert] = useState(false);
  const [buttonDisable, setButtonDisable] = useState(false);

  const dispatch = useDispatch();
  const [api, contextHolder] = notification.useNotification();

  const openNotificationWithIcon = (type) => {
    api[type]({
      message: "Şöbə əlavə edildi!",
    });
  };

  const handleChange = (value) => {
    setCompanyName(value);
  };

  useEffect(() => {
    getAllCompanyNames();
  }, [GlobalResponse.triggeranyevent]);

  const getAllCompanyNames = async () => {
    let result = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/get-company-names/`,
      {
        headers: {
          authorization: `bearer ${JSON.parse(localStorage.getItem("token"))} `,
        },
      }
    );
    result = await result.json();
    const uniqueResults = result.filter((item, index, array) => {
      return array.findIndex((obj) => obj.value === item.value) === index;
    });
    dispatch(setAllCompanyNames(uniqueResults));
  };

  const saveDepartment = async () => {
    if (departmentName && companyName) {
      setButtonDisable(true);
      setShowAlert(false);

      let result = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/add-department/`,
        {
          method: "post",
          body: JSON.stringify({
            departmentName,
            companyName,
            employeeCount,
          }),
          headers: {
            "Content-Type": "application/json",
            authorization: `bearer ${JSON.parse(
              localStorage.getItem("token")
            )} `,
          },
        }
      );
      result = await result.json();

      if (result) {
        setButtonDisable(false);
        dispatch(setTriggerAnyEvent(Math.random()));
        setDepartmentName("");
        setCompanyName("");
        openNotificationWithIcon("success");
      }
    } else {
      setShowAlert(true);
    }
  };

  return (
    <>
      {contextHolder}
      {showAlert && (
        <Alert
          onClose={() => setShowAlert(false)}
          message="Diqqət!"
          description="Zəhmət olmasa boş sahələri doldurun!"
          type="warning"
          showIcon
          closable
        />
      )}

      <Row className="add-row">
        <Col span={8}>
          <Typography.Text className="add-title">Şöbənin adı</Typography.Text>
          <Input
            className="add-input"
            size="large"
            value={departmentName}
            onChange={(e) => setDepartmentName(e.target.value)}
          />
        </Col>
        <Col span={8}>
          <Typography.Text className="add-title">Şirkət</Typography.Text>

          <Select
            value={companyName}
            size="large"
            onChange={handleChange}
            className="add-dropdown"
            options={MainResponse.allCompanyNames}
          />
        </Col>
        <Col span={8}>
          <button
            disabled={buttonDisable}
            onClick={saveDepartment}
            className="add-button"
          >
            Əlavə Et
          </button>
        </Col>
      </Row>
    </>
  );
};

export default AddDepartment;
